import type { ReactNode } from "react";

interface SectionHeadProps {
  kicker?: ReactNode;
  title?: ReactNode;
  right?: ReactNode;
  narrow?: boolean;
}

/**
 * Editorial section heading: small uppercase mono kicker over a large
 * serif title, with optional right-side widget (chips, dates).
 */
export function SectionHead({ kicker, title, right, narrow = false }: SectionHeadProps) {
  return (
    <div
      className={narrow ? "container-narrow" : "container"}
      style={{ paddingTop: "var(--s-7)", paddingBottom: "var(--s-5)" }}
    >
      <div className="row-s" style={{ alignItems: "flex-end", gap: "var(--s-5)", flexWrap: "wrap" }}>
        <div className="stack" style={{ gap: 6 }}>
          {kicker && <div className="t-eyebrow">{kicker}</div>}
          {title && <h1 className="t-display" style={{ margin: 0, fontSize: "var(--t-3xl)" }}>{title}</h1>}
        </div>
        {right && <div>{right}</div>}
      </div>
    </div>
  );
}
